import { ConvertedRealEstate } from '../../../../@types/real-estate-api-types'
import React, { useMemo, useState } from 'react'
import { filterObjectsBySearchPhrase } from './utils/objectUtils'
import TextInput from '../../../common/inputs/textInput/TextInput'
import { IconS24Filter24 } from '@is24/cosma-ui-icons'
import { ObjectChooserItem } from './components/objectChooserItem/ObjectChooserItem'
import { useGroupedObjects } from './utils/hooks'
import { useTranslation } from 'react-i18next'

export default function ObjectChooser(props: { objects: ConvertedRealEstate[] }) {
  const objects = props.objects
  const { t } = useTranslation()
  const [search, setSearch] = useState('')

  const filteredObjects: ConvertedRealEstate[] = useMemo(
    () => filterObjectsBySearchPhrase(objects, search),
    [objects, search]
  )
  const shouldDisplaySearch = objects.length > 8
  const objectsByAddress = useGroupedObjects(filteredObjects)

  return (
    <div className='padding-bottom-xl' style={{ flexGrow: 1 }}>
      <div className='grid grid-flex grid-justify-space-between'>
        <div className='grid-item'>
          <h3 className='text-heading-3'>{t('objectChooser.heading')}</h3>
        </div>
        <div className='grid-item palm-one-whole pii-hide'>
          {shouldDisplaySearch && (
            <TextInput
              placeholder={t('objectChooser.searchPlaceholder')}
              errors={[]}
              doOnFieldChange={(_, value) => value !== undefined && setSearch(value.toString())}
              propertyName='custom'
              value={search}
              id='objectSearch'
              affixRight='icon'
              iconRight={<IconS24Filter24 />}
              label=''
            />
          )}
        </div>
      </div>

      <div className='grid grid-flex gutter-m margin-top-none'>
        {filteredObjects.length > 0 ? (
          Object.entries(objectsByAddress).map(([key, objects]) => (
            <div key={key} className='grid-item one-fourth palm-one-whole lap-one-half'>
              <ObjectChooserItem objects={objects} />
            </div>
          ))
        ) : (
          <div className={'one-whole align-center font-body-large-bold margin-top-xl margin-bottom-m'}>
            {t('objectChooser.noMatchingObjects')}
          </div>
        )}
      </div>
    </div>
  )
}
